<template>
  <div id="srpRoot">
    <modifySearch @updatePackages="getPackages" :initialValues="{destination: destinationName, departure: holidayData.searchParams.htmlEscapedDeparture, monthYear: monthyear, departureCityId: holidayData.searchParams.departureCityId}" />

    <multiFilter ref="packagesFilter" v-if="holidayData && packages && packages.length > 0" @filterChanged="updatePackages" :outSideFilter="outsidePriceFilter" :packages="packages" :promoBannerImages="promoBannerImages" :filterMO="holidayData && holidayData.filterMO" :packageCompareToggled="packageCompareToggled" :themeFilter="themeFilter" @openslideout="openSlideout" />

    <section class="packages-list">
      <hangingIcons @openLeadForm="openSlideout({slideOutName:'leadManager', props:{ destination: destinationName, leadFormMessage: leadFormMessage}})" :tollfree="tollFreeNumber" :leadFormMessage="leadFormMessage" :contactUsConfig="contactUsConfig"></hangingIcons>
      <div class="hd-container sme-container-fluid">

        <template v-if="!loadingPackages">
          <div class="nothing-found" v-if="!packagesToDisplay || packagesToDisplay.length == 0" :style="{'margin-top': !packages || packages.length == 0 ? '20px' : '0px'}">
            <p class="message" v-if="packages && packages.length > 0">
              No results found matching your search criterion. Please change or
              <a href="" @click.prevent="$refs.packagesFilter.resetFilter()">reset all filters</a>.
            </p>
            <p class="message" v-else>
              Sorry, currently there are no packages to your destination.
            </p>
          </div>
          <package v-else @packageCompareToggled="packageCompareToggled++" @openslideout="openSlideout" :pkg="pkg" v-for="pkg in packagesToDisplay.slice(0,noOfPackagesToList)" :key="pkg.packageId" @openGallery="openGallery" :packageCompareToggled="packageCompareToggled" :userPayAndHoldEnabled ="userPayAndHoldEnabled "></package>

        </template>
        <packageLoader v-else v-for="index in 3" :key="index"></packageLoader>
      </div>
    </section>

    <slideOut ref="slideOut" :current-slideout="currentSlideout" :dynamic-props="dynamicProps" @packageCompareToggled="comparePackageToggled" />
    <gallery v-if="showGallery" :imagesList="galleryImages"></gallery>
    <loader :showLoader="displayLoader"></loader>
  </div>

</template>

<script>
/* global holidayData globalConfig yt_adobe */

import axios from 'axios'

import pkg from './components/packageTuple'
import modifySearch from './components/modify-search'
import slideOut from './components/slide-out'
import multiFilter from './components/multi-filter'
import recommendations from './components/recommendation'
import gallery from './components/gallery'
import packageLoader from './components/package-loader'
import URLs from './common/URLStore'
import loader from './components/loader'
import hangingIcons from './components/hanging-icons'
import preload from './common/preload'
import constantData from './common/constants'

export default {
  name: 'app',
  mixins: [preload],
  components: {
    package: pkg,
    modifySearch: modifySearch,
    slideOut: slideOut,
    multiFilter: multiFilter,
    recommendations,
    gallery,
    packageLoader,
    loader,
    hangingIcons
  },
  data() {
    return {
      contactUsConfig: {
        showSpeakToAnExpert: true,
        showCustomerCareNumber: true
      },
      displayLoader: false,
      galleryImages: [],
      showGallery: false,
      packagesPerPage: 10,
      noOfPackagesToList: 10,
      compareToggled: false,
      recommendationsPosition: 2,
      currentSlideout: null,
      dynamicProps: null,
      packages: [],
      selectedTourType: 0,
      packagesToDisplay: [],
      holidayData: {},
      outsidePriceFilter: {},
      loadingPackages: false,
      destinationName: null,
      departureName: null,
      preventLeadOpen: false,
      packageCompareToggled: 0,
      tollFreeNumber: '',
      leadFormMessage: {}
    }
  },
  watch: {
    noOfPackagesToList: function(newValue) {
      if (newValue && this.packagesToDisplay && this.packagesToDisplay.length > 0) {
        let targetPackages = this.packagesToDisplay.slice(0, newValue)
        let imagesList = targetPackages.map(pkg => {
          return [pkg.packageId, pkg.defaultSrpimg]
        })

        if (imagesList.length > 0) {
          let that = this
          imagesList.forEach(img => {
            let imgObject = new Image()
            imgObject.src = img[1]

            that.getPacakgeMedia(img[0]).then(resp => {
              if (resp.packageImages.length > 0) {
                let downloadCount = resp.packageImages.length < 3 ? resp.packageImages : 3
                for (var x = 0; x < downloadCount; x++) {
                  let imgObject = new Image()
                  imgObject.src = resp.packageImages[x].transformedImages.responsivedetailslargeimg.url
                }
              }
            })
          })
        }
      }
    }
  },
  beforeCreate: function() {
    try {      
      if (holidayData && holidayData.searchParams && holidayData.searchParams.destination) {
        axios
          .get(URLs.getTypeOfLeadData, {
            headers: {
              Authorization: window.lrsDetails.lrsApiKey,
              'com.yatra.tenant.header.tenantId': window.lrsDetails.lrstenantId
            }
          })
          .then(response => {
            if (response && response.data && response.data.status && response.data.messages && response.data.messages.length > 0) {
              let messages = response.data.messages.reduce((messages, item) => (messages[item.messageKey] = item.messageValue, messages) ,{});
              this.leadFormMessage = messages
              this.leadFormMessage.isLeadFormEnabled = response.data.isLeadFormEnabled
              this.autoPopUpOpen()
            } else {
              this.setDefaultLeadFormData()
            }
          })
          .catch(() => {
            this.setDefaultLeadFormData()
          })
      } else {
        this.setDefaultLeadFormData()
      }
    } catch(error) {
      console.log(error)
      setTimeout(() => {
        this.setDefaultLeadFormData()
      },0)      
    }    
  },
  created: function() {
    this.promoBannerImages = window.promoBannerImages
    this.contactUsConfig.showSpeakToAnExpert = window.showSpeakToAnExpert
    this.contactUsConfig.showCustomerCareNumber = window.showCustomerCareNumber
    this.isFranchisee = window.isFranchisee
    this.userPayAndHoldEnabled  = window.userPayAndHoldEnabled
    if (typeof holidayData !== 'undefined' && holidayData) {
      this.setholidaysData(holidayData)
    }

    let that = this
    this.autoPopUpOpen = function() {
    	if (globalConfig.isMarketplaceOnlyPackages || (this.contactUsConfig.showSpeakToAnExpert && this.leadFormMessage.isLeadFormEnabled)) {
	      setTimeout(() => {
	        if (!this.preventLeadOpen) {
	          this.openSlideout({ slideOutName: 'leadManager', props: { destination: that.destinationName, leadFormMessage: that.leadFormMessage } })
	        }
	      }, globalConfig.autoPopupTimer)
	    }
    }
    
    var lastScrollValue = 0

    window.addEventListener('scroll', event => {
      var documentElement = document.documentElement
      var docBody = document.body
      var scrollTop = 'scrollTop'
      var scrollHeight = 'scrollHeight'
      var scrollPercent = (documentElement[scrollTop] || docBody[scrollTop]) / ((documentElement[scrollHeight] || docBody[scrollHeight]) - documentElement.clientHeight) * 100
      if (scrollPercent > 70) {
        if (window.pageYOffset > lastScrollValue) {
          if (this.packagesToDisplay && this.packagesToDisplay.length > this.noOfPackagesToList) {
            this.noOfPackagesToList += this.packagesPerPage
          }
        }
      }
      lastScrollValue = window.pageYOffset
    })

    if (typeof yt_adobe !== 'undefined' && typeof yt_adobe.addDigitalData == 'function') {
      var obj = {}
      obj.page = {
        pageInfo: {
          pageName: 'yt:holiday:dom:srp',
          lob: 'holiday'
        },
        category: {
          pageType: 'business',
          primaryCategory: 'holiday srp',
          subCategory1: 'domestic holiday',
          subCategory2: holidayData !== null && holidayData.searchParams !== null && holidayData.searchParams.destinationId !== null ? holidayData.searchParams.destinationId : '',
          subCategory3: ''
        }
      }
      if (holidayData && holidayData.searchParams && !holidayData.searchParams.isDomestic) {
        obj.page.pageInfo.pageName = 'yt:holiday:int:srp'
        obj.page.category.subCategory1 = 'international holiday'
      }
      yt_adobe.addDigitalData(obj)
    }
  },
  mounted: function() {
    var oneTimehandler = () => {
      this.preventLeadOpen = true
      document.getElementById('srpRoot').removeEventListener('click', oneTimehandler)
    }

    document.getElementById('srpRoot').addEventListener('click', oneTimehandler)

    // fixing filter on scroll
    setTimeout(() => {
      var header = document.getElementById('filter-section')
      var sticky = header.offsetTop

      function stickHeader() {
        if (window.pageYOffset >= sticky) {
          header.classList.add('sticky')
        } else {
          header.classList.remove('sticky')
        }
      }

      window.onscroll = function() {
        stickHeader()
      }
    }, 1000)
  },
  methods: {
    setDefaultLeadFormData: function() {
      this.leadFormMessage = constantData.srpLeadFormMessages
      this.leadFormMessage.isLeadFormEnabled = true
      this.autoPopUpOpen()
    },
    comparePackageToggled: function() {
      this.packageCompareToggled++
      this.compareToggled = !this.compareToggled
    },
    setholidaysData: function(holidayData) {
      this.destinationName = holidayData.searchParams.htmlEscapedDestination
      this.departureName = null // holidayData.searchParams.htmlEscapedDeparture
      // var departureCityId = holidayData.searchParams.departureCityId

      /* if (departureCityId && holidayData.departureCities !== null) {
        for (var i = 0, len = holidayData.departureCities.length; i < len; i++) {
          if (holidayData.departureCities[i].cityCode == departureCityId) {
            this.departureName = holidayData.departureCities[i].cityName
          }
        }
      } */

      // set initial month  year data
      if (holidayData.searchParams.monthYear) {
        this.monthyear = holidayData.searchParams.monthYear.month + ' ' + holidayData.searchParams.monthYear.year
      }

      this.holidayData = holidayData
      this.packages = this.holidayData.packages
      this.packagesToDisplay = this.filteredPackages = this.packages
      this.tollFreeNumber = holidayData.tollFreeNumber
      this.themeFilter = holidayData && holidayData.searchParams ? holidayData.searchParams.packageTheme : null
    },
    clearHolidaysData: function() {
      this.holidayData = null
      this.packages = null
      this.packagesToDisplay = this.filteredPackages = null
    },
    getPackages: function(reqObj) {
      var paramsObject = {}
      reqObj.destination ? (paramsObject.destination = reqObj.destination) : ''
      reqObj.departure ? (paramsObject.departure = reqObj.departure) : ''

      this.loadingPackages = true
      this.clearHolidaysData()
      axios
        .post(URLs.getpackages, reqObj)
        .then(response => {
          this.setholidaysData(response.data.data)
          this.loadingPackages = false
        })
        .catch(() => {
          this.loadingPackages = false
        })
    },
    applyPriceFilter: function(data) {
      this.outsidePriceFilter = data
    },
    openSlideout: function(data) {
      this.currentSlideout = data.slideOutName
      this.dynamicProps = data.props
      this.$refs.slideOut.showSlideout()
    },
    openCompareSlideout: function() {
      this.currentSlideout = 'packages-compare'
      this.dynamicProps = {}
      this.$refs.slideOut.showSlideout()
    },
    updatePackages: function(data) {
      this.noOfPackagesToList = this.packagesPerPage
      this.packagesToDisplay = data.filteredPackages
      this.filteredPackages = data.filteredPackages
    },
    openGallery: function(data) {
      this.galleryImages = data.packageImages
      this.showGallery = !this.showGallery
      document.getElementsByTagName('html')[0].style.overflowY = 'hidden'
    }
  },
  destroyed: function() {
    window.removeEventListener('scroll', function() {})
  }
}
</script>

<style  lang="scss">
@import 'assets/css/calendar.css';
// @import 'assets/css/airline-logos.css';

.drop-in-enter {
  transform: translateY(-10px);
}

.drop-in-enter-active {
  transition: transform 0.4s ease-in;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.loader-container:first-child {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue